import { render, staticRenderFns } from "./AnalysesOnlineOrderBenefit.vue?vue&type=template&id=1b5d77a8&scoped=true&"
import script from "./AnalysesOnlineOrderBenefit.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesOnlineOrderBenefit.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesOnlineOrderBenefit.vue?vue&type=style&index=0&id=1b5d77a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d77a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5d77a8')) {
      api.createRecord('1b5d77a8', component.options)
    } else {
      api.reload('1b5d77a8', component.options)
    }
    module.hot.accept("./AnalysesOnlineOrderBenefit.vue?vue&type=template&id=1b5d77a8&scoped=true&", function () {
      api.rerender('1b5d77a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesOnlineOrderBenefit.vue"
export default component.exports